import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

const SECTIONS = [
  {
    id: "servizio",
    title: "1. Il servizio",
    body: ["Medico delle Piante è un'applicazione che offre un percorso guidato per l'osservazione e l'analisi preliminare dei problemi delle piante. L'analisi approfondita è attualmente disponibile per il limone e gli altri agrumi. Ulteriori piante potranno essere aggiunte progressivamente."],
  },
  {
    id: "analisi-ai",
    title: "2. L'analisi preliminare AI",
    body: [
      "L'analisi viene generata automaticamente da un sistema di intelligenza artificiale sulla base delle fotografie caricate e delle risposte fornite durante l'anamnesi.",
      "L'analisi AI è preliminare: non sostituisce una diagnosi professionale, un'osservazione diretta o un esame di laboratorio quando questi sono necessari.",
    ],
  },
  {
    id: "consulenza",
    title: "3. La consulenza professionale",
    body: [
      "La consulenza professionale della Dott.ssa Luigia De Vanna è distinta dall'analisi preliminare AI e viene avviata solo su tua richiesta, dopo aver autorizzato il trasferimento di fotografie, anamnesi e analisi preliminare.",
      "Dopo la richiesta sarai contattato/a per conoscere modalità e costo della consulenza prima di procedere.",
    ],
  },
  {
    id: "account",
    title: "4. Account e analisi disponibili",
    body: [
      "Per utilizzare l'analisi è necessario creare un account con nome, cognome ed email.",
      "Ogni account riceve 1 analisi completa gratuita iniziale. Un'analisi viene scalata solo quando il risultato è stato generato correttamente. Il numero di analisi disponibili è sempre visibile nell'app.",
    ],
  },
  {
    id: "acquisti",
    title: "5. Acquisto di analisi",
    body: [
      "Quando vuoi effettuare ulteriori analisi puoi acquistare pacchetti di analisi. I pacchetti disponibili e i relativi prezzi, IVA inclusa ove applicabile, sono quelli visualizzati nell'app al momento dell'acquisto. Il prezzo applicabile è quello mostrato e confermato al momento del pagamento.",
      "Il pagamento è unico e avviene sulla pagina sicura di Stripe: non è previsto alcun abbonamento o rinnovo automatico. Le analisi vengono accreditate automaticamente al tuo account dopo la conferma del pagamento.",
      "Le analisi acquistate non hanno scadenza, si sommano a quelle già disponibili e valgono esclusivamente per le analisi automatizzate dell'app. Non comprendono la consulenza professionale della Dott.ssa Luigia De Vanna descritta al punto 3.",
    ],
  },
  {
    id: "dati",
    title: "6. Dati personali",
    body: ["Il trattamento dei dati è descritto nell'Informativa privacy. Dal Profilo puoi modificare i consensi, esportare i tuoi dati o cancellare l'account e i dati collegati."],
  },
];

export default function Terms() {
  return (
    <div className="space-y-4 px-5 py-6" data-testid="terms-page">
      <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[#c9a96e] text-[#0d2517]"><FileText /></span>
      <div>
        <p className="eyebrow">Termini di utilizzo</p>
        <h1 className="font-serif text-3xl font-semibold text-[#0d2517]">Come funziona Medico delle Piante</h1>
      </div>
      {SECTIONS.map((s) => (
        <section key={s.id} className="space-y-2 rounded-2xl border border-[#E2DCD0] bg-white p-4 text-sm text-[#2D3A30]" data-testid={`terms-${s.id}`}>
          <h2 className="font-serif text-lg font-semibold text-[#0d2517]">{s.title}</h2>
          {s.body.map((p) => <p key={p}>{p}</p>)}
        </section>
      ))}
      <section className="space-y-2 rounded-2xl border border-[#E2DCD0] bg-white p-4 text-sm text-[#2D3A30]" data-testid="terms-contatti">
        <h2 className="font-serif text-lg font-semibold text-[#0d2517]">7. Contatti</h2>
        <p>Per informazioni puoi scrivere a <a href="mailto:info@luigiadevanna.it" className="underline">info@luigiadevanna.it</a>.</p>
      </section>
      <Link to="/privacy" className="btn-secondary w-full bg-white" data-testid="terms-privacy-link">Informativa privacy</Link>
    </div>
  );
}
